import React from "react";
import { StyledTotemOption } from "./TotemOptionStyles";

interface Props {
  title: string;
  subtitle?: string;
  extraText?: string;
  isselected: boolean;
  execSelection: () => void;
  disabled?: boolean;
}

const TotemOption: React.FC<Props> = ({
  title,
  subtitle = "",
  extraText = "",
  isselected,
  execSelection,
  disabled = false,
}: Props) => {
  const renderSubtitle = subtitle ? (
    <>
      <br />
      {""}
      <br />
      {subtitle}
    </>
  ) : (
    <></>
  );

  const renderExtraText = extraText ? (
    <>
      <br />
      {""}
      <br />
      {extraText}
    </>
  ) : (
    <></>
  );

  const handleSelection = () => {
    if (disabled) return;

    execSelection();
  };

  return (
    <StyledTotemOption
      isselected={isselected}
      onClick={handleSelection}
      disabled={disabled}
    >
      {title}
      {renderSubtitle}
      {renderExtraText}
    </StyledTotemOption>
  );
};

export default TotemOption;
